var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.6667 4.32139C29.3899 5.22203 27.9762 5.91087 26.48 6.36139C25.677 5.43807 24.6098 4.78365 23.4227 4.48663C22.2357 4.1896 20.986 4.26432 19.8428 4.70066C18.6996 5.13701 17.7179 5.91393 17.0307 6.92635C16.3434 7.93877 15.9836 9.13784 16 10.3614V11.6947C13.6569 11.7555 11.335 11.2358 9.24136 10.182C7.14767 9.12816 5.3471 7.57291 4.00001 5.65472C4.00001 5.65472 -1.33332 17.6547 10.6667 22.9881C7.92071 24.852 4.64955 25.7866 1.33334 25.6547C13.3333 32.3214 28 25.6547 28 10.3214C27.9988 9.95 27.9631 9.57952 27.8933 9.21472C29.2541 7.87272 30.2144 6.17834 30.6667 4.32139V4.32139Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.43d5244dfa413434fe891e62bd4b2891.svg";
export { ForwardRef as ReactComponent };